import React from 'react';
//import renderIf from '../../../../../pkgs/render_if';
import $ from 'jquery';

import {
  Form,
  Button,
} from 'react-bootstrap';

export default class XeditableForeignKeyField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: 'inline',
      refresh: undefined,
      value:'',
    }
  }

  componentDidMount = () => {
    //console.log('This is componentDidMount of xeditable table')
    //setTimeout(() => this.renderEditable(), 1000 );
    this.setState({refresh:this.props.getCounter()});
    setTimeout(() => this.renderEditable(), 500 );
    
  }


  componentWillReceiveProps = (nextProps) => {
    setTimeout(() => this.renderEditable(), 500 );
    this.setState({refresh:nextProps.getCounter()});
    //if (nextProps.loading === false) {
      //if (nextProps.options_loading === false) {
        //let p = nextProps.ajax_json_options;
        //let data = nextProps.ajax_json_response;
        //this.getForeignKeyFields(p, data);
        //this.renderEditable();
      //}
    //}
  }

  renderEditable() {

    // $.ajaxSetup({
    //     headers: {'Authorization': 'Token ' + localStorage.token},
    // });

    $(`.${this.props.reference}`).editable({
      params: function(params) {  //params already contain `name`, `value` and `pk`
        var data = {};
        data[params.name] = params.value;
        return data;
      },
      showbuttons : false,
      mode: 'inline',
      display: String($(this).data('placeholder')),
      placeholder: String($(this).data('placeholder')),
      source: function() {
        //TODO: Make Select2 load after the following line to not load every field.
        //if ($(this).data('editable')) {
        //console.log('here is xeditable fk id');
        let id = String($(this).data('pk')).split('-')[0];
        //console.log(id);
        //console.log('here is xeditable field');
        let field = $(this).data('pk').split('-')[1];
        //console.log(field);
        //console.log('here is xeditable app');
        field = String(field).split('_').join('')
        let model= $(this).data('pk').split('-')[2]
        //console.log(model);
        //console.log('here is xeditable model');
        let app = $(this).data('pk').split('-')[3]
        //console.log(app);
        //console.log(field);
        let result;
        return '/api/x/' + app + '/' + field + '/';
      },
      select2: {
        width: 250,
        allowClear: true,
      },
      success: function(response, newValue) {

        //console.log('xeditable FK success');
        let id = $(this).data('pk').split('-')[0];
        ///console.log(id);
        //console.log('here is xeditable field');
        let field = $(this).data('pk').split('-')[1];
        //console.log(field);
        //console.log('here is xeditable app');
        let model= $(this).data('pk').split('-')[2]
        //console.log(model);
        //console.log('here is xeditable model');
        let app = $(this).data('pk').split('-')[3]
        //console.log(app)
        let instance = {};
        instance[field] = Number(newValue);

        console.log('newValue');
        console.log(newValue);
        let cookie;
        let c_name = 'csrftoken';

        if(document.cookie.length > 0) {
            let c_start = document.cookie.indexOf(c_name + "=");
            if(c_start != -1) {
                c_start = c_start + c_name.length + 1;
                let c_end = document.cookie.indexOf(";", c_start);
                if(c_end == -1) c_end = document.cookie.length;
                cookie = unescape(document.cookie.substring(c_start,c_end));
            }
        } else {
            cookie = "";
        }

        $.ajax({
            url: '/api/xeditable/patch/' + app + '/' + model + '/' + id + '/',
            dataType: 'json',
            headers: {"X-CSRFToken": cookie},
            method: 'PUT',
            data: instance,
            success: (data) => {
              console.log('Yay, we submitted a change.')
            }
        })
      }
    });
  }

  componentDidMount = () => {
    //setTimeout(() => this.renderEditable(), 1000 );
    setTimeout(() => this.renderEditable(), 500 );

  }

  componentWillReceiveProps = (nextProps) => {
    setTimeout(() => this.renderEditable(), 500 );

  }

  render() {
    return (
      <a
        href='#'
        id={this.props.reference}
        data-pk={this.props.reference}
        key={this.props.reference}
        className={`${this.props.reference}`}
        data-type='select2'
        data-value={this.props.data_value}
        data-placeholder={this.props.value}
        data-title='Change field'
      >
        {this.props.value}
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/helpers/field/xeditable/xeditable_edit_foreign_key_field.js